// import Swup from 'swup';
import Lenis from 'lenis'
import { setup } from './utils/setup';
// import { Easing } from './utils/math/easing';
import initPopup from './modules/popup';
import { initHomeMvCarousel, initHomeInterviewCarousel } from './modules/carousels';
import initBackToTop from './modules/backToTop';
import initHeaderMenu from './modules/header';
import initAboutPage from './page/about';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import initInview from './modules/inview';
import { SplitText } from 'gsap/SplitText';
import Splide from '@splidejs/splide';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);


const initMouseStorker = () => {
  const $el = document.querySelector<HTMLElement>('#js_mousestoker');  
  if(!$el) return;
  const $storkerItem = $el.querySelector<HTMLElement>('.el_mouseStorker_item');
  // document.body.style.cursor = 'none';
  gsap.set($el, {
    display: 'block',
  });
  const currentMousePosition = {
    x: 0,
    y: 0,
  };
  const targetMousePosition = {
    x: 0,
    y: 0,
  };
  
  window.addEventListener('mousemove', (e) => {    
    targetMousePosition.x = e.clientX;
    targetMousePosition.y = e.clientY;
  });
  
  const allLinkAndButtons = document.querySelectorAll('a, button');  
  allLinkAndButtons.forEach(linkOrButton => {
    linkOrButton.addEventListener('mouseenter', () => {
      document.body.style.cursor = 'auto';
      gsap.to($el, {
        scale: 0,
        duration: 0.3,
        ease: 'power3.out',
      });
    });
    linkOrButton.addEventListener('mouseleave', () => {
      document.body.style.cursor = 'none';
      gsap.to($el, {
        scale: 1,
        duration: 0.3,
        ease: 'power3.out',
      });
    });
  });

  const orangeBgElements = document.querySelectorAll<HTMLElement>('[data-bg="orange"]');
  orangeBgElements.forEach(($target) => {
    $target.addEventListener('mouseenter', () => {
      if (!$storkerItem) return;
      $storkerItem.style.borderColor = '#0F68C8';
      // $el.style.mixBlendMode = 'difference';
    });
    $target.addEventListener('mouseleave', () => {
      if (!$storkerItem) return;
      $storkerItem.style.borderColor = '';
      // $el.style.mixBlendMode = '';
    });
  });

  const frame = () => {
    requestAnimationFrame(frame);
    const distance = {
      x: targetMousePosition.x - currentMousePosition.x,
      y: targetMousePosition.y - currentMousePosition.y,
    };
    currentMousePosition.x += distance.x * 0.1;
    currentMousePosition.y += distance.y * 0.1;
    
    $el.style.left = `${currentMousePosition.x}px`;
    $el.style.top = `${currentMousePosition.y}px`;
  }
  frame();
}

const initRecruitCarousel = () => {
  const $el = document.querySelector<HTMLElement>('.js_recruit_crousel');
  if(!$el) return;
  const carousel = new Splide($el, {
    type: 'fade',    
    rewind: true,
    perPage: 1,
    arrows: false,
    pagination: false,
    autoplay: true,
    interval: 5000,    
  });
  carousel.mount();
}


const initContactForm = () => {
  const $form = document.querySelector<HTMLFormElement>('#js_contact_form');
  if (!$form) return;

  const $email = $form.querySelector<HTMLInputElement>('input[name="email"]');
  const $emailConfirm = $form.querySelector<HTMLInputElement>('input[name="email_confirm"]');
  const $contactTypes = Array.from(
    $form.querySelectorAll<HTMLInputElement>('input[name="type[]"]'),
  );

  const updateContactTypeValidity = () => {
    if ($contactTypes.length === 0) return;
    const hasChecked = $contactTypes.some(($input) => $input.checked);
    const message = hasChecked ? '' : 'お問い合わせ種別を1つ以上選択してください。';
    $contactTypes.forEach(($input) => $input.setCustomValidity(message));
  };

  const updateEmailConfirmValidity = () => {
    if (!$emailConfirm) return;
    if (!$emailConfirm.value) {
      $emailConfirm.setCustomValidity('');
      return;
    }

    if ($email && $email.value !== $emailConfirm.value) {
      $emailConfirm.setCustomValidity('メールアドレスが一致しません。');
      return;
    }

    $emailConfirm.setCustomValidity('');
  };

  const setJapaneseValidationMessage = ($target: HTMLInputElement | HTMLTextAreaElement) => {
    if ($target.validity.valueMissing) {
      $target.setCustomValidity('この項目は必須です。');
      return;
    }
    if ($target.validity.typeMismatch) {
      if ($target.type === 'email') {
        $target.setCustomValidity('メールアドレスの形式で入力してください。');
        return;
      }
      if ($target.type === 'url') {
        $target.setCustomValidity('URLの形式で入力してください。');
        return;
      }
    }
    if ($target.validity.patternMismatch) {
      if ($target.name === 'kana') {
        $target.setCustomValidity('お名前（カナ）は全角カタカナで入力してください。');
        return;
      }
      if ($target.name === 'tel') {
        $target.setCustomValidity('電話番号は数字と記号（-+()）で入力してください。');
        return;
      }
      $target.setCustomValidity('入力形式が正しくありません。');
      return;
    }
    if ($target.validity.tooShort) {
      $target.setCustomValidity(`あと${$target.minLength - $target.value.length}文字以上入力してください。`);
      return;
    }
    if ($target.validity.tooLong) {
      $target.setCustomValidity(`${$target.maxLength}文字以内で入力してください。`);
      return;
    }
    $target.setCustomValidity('');
  };

  const clearValidationMessage = ($target: HTMLInputElement | HTMLTextAreaElement) => {
    $target.setCustomValidity('');
  };

  $contactTypes.forEach(($input) => {
    $input.addEventListener('change', () => {
      updateContactTypeValidity();
      $input.reportValidity();
    });
  });

  if ($email) {
    $email.addEventListener('input', () => {
      clearValidationMessage($email);
      updateEmailConfirmValidity();
    });
    $email.addEventListener('invalid', () => {
      setJapaneseValidationMessage($email);
    });
  }

  if ($emailConfirm) {
    $emailConfirm.addEventListener('input', () => {
      clearValidationMessage($emailConfirm);
      updateEmailConfirmValidity();
    });
    $emailConfirm.addEventListener('invalid', () => {
      updateEmailConfirmValidity();
      if ($emailConfirm.validity.customError) return;
      setJapaneseValidationMessage($emailConfirm);
    });
  }

  const $inputs = Array.from(
    $form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea'),
  );

  $inputs.forEach(($input) => {
    $input.addEventListener('input', () => {
      clearValidationMessage($input);
      if ($input.name === 'email_confirm') {
        updateEmailConfirmValidity();
      }
    });
    $input.addEventListener('invalid', () => {
      if ($input.name === 'email_confirm') {
        updateEmailConfirmValidity();
        if ($input.validity.customError) return;
      }
      setJapaneseValidationMessage($input);
    });
  });

  $form.addEventListener('submit', (e) => {
    updateContactTypeValidity();
    updateEmailConfirmValidity();

    if (!$form.checkValidity()) {
      e.preventDefault();
      $form.reportValidity();
    }
  });

  $form.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    if (e.isComposing) return;

    const $target = e.target as HTMLElement | null;
    if (!$target) return;
    if ($target instanceof HTMLTextAreaElement) return;

    e.preventDefault();
  });
}

const initCtaPic = () => {
  const $wrapper = document.querySelector<HTMLElement>('.js_cta');
  if(!$wrapper) return;
  const $els = gsap.utils.toArray<HTMLElement>('.js_cta_pic',$wrapper);

  $els.forEach(($el, index) => {
    gsap.fromTo($el, {      
      yPercent: 7 * (index % 2 === 0 ? 1 : -1),
    }, {     
      yPercent: 7 * (index % 2 === 0 ? -1 : 1),
      duration: 1,      
      ease: "none",
      scrollTrigger: {
        trigger: $wrapper,
        start: "top bottom",
        end: "bottom top",
        scrub: true,               
      }
    });
  })
}

const initPages = ({lenis}: {lenis: Lenis}) => {
  // console.log("initPages");
  ScrollTrigger.refresh();  
  initPopup({lenis: lenis});
  initHomeMvCarousel();  
  initHomeInterviewCarousel();
  initBackToTop({lenis: lenis});
  initHeaderMenu({lenis: lenis});
  initInview();
  initAboutPage();
  initMouseStorker();  
  initRecruitCarousel();
  initCtaPic();
  initContactForm();
}

// domcontentloaded
document.addEventListener('DOMContentLoaded', () => {    
  // const swup = new Swup();

  const lenis = new Lenis({
      autoRaf: true,
    });     

  // lenis.on('scroll', (e) => {
    // console.log(lenis.scroll.y);        
  // });
  setup();    
  initPages({lenis: lenis});

  // 新ページの JS 初期化、ビューのトラッキング
  // swup.hooks.on("page:view", (e) => {
  //   // console.log("visite:end", e);     
  //   initPages({lenis: lenis});   
  // });

  // 遷移全体の終了処理、ログ、同期処理
  // swup.hooks.on("visit:end", (e) => {
  //   console.log("visite:end", e);
  // }); 

      
});